import { SaldoBancarioCadastroForm } from "../../../presentation/schemas/SaldoBancario_cadastro/SaldoBancario_cadastro";
import { ICreateSaldoBancarioUseCase } from "../../../presentation/useCases/create/create_saldo_bancario_use_case";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * CreateSaldoBancarioUseCase
 */

export class CreateSaldoBancarioUseCase implements ICreateSaldoBancarioUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }

  async createSaldoBancario(form: SaldoBancarioCadastroForm): Promise<void> {
    await this.repository.createSaldoBancario(form);

  }

}
